module.exports = __webpack_public_path__ + "img/Vista al mar.378bbd41.png";